import React, { FC } from 'react'
import { Carousel, Box } from '@moonpig/launchpad-components'
import { USP } from './components/USP'
import { ModuleUspCarouselFragment } from './__generated__/fragment'
import { Module } from '../types'
import { ModuleSection } from '../../components/ModuleContainer'
import { useFindLocaleText } from '../../text-localisation'

export const USPCarouselModule: FC<Module<ModuleUspCarouselFragment>> = ({
  module: { items },
  context: { backgroundColor },
}) => {
  const t = useFindLocaleText()

  return (
    <ModuleSection
      data-testid="module-usp-carousel"
      padding={{ py: 0 }}
      margin={{ my: 8 }}
      backgroundColor={backgroundColor}
      withContainer
    >
      <Carousel centerNonScrollableItems aria-label={t('find.usp_carousel')}>
        {items.map(({ title, description, icon }) => {
          return (
            <Box key={title} marginX={{ xs: 0, md: 8 }}>
              <USP
                title={title}
                description={description}
                image={
                  icon
                    ? {
                        iconImageUrl: icon.url,
                        lazyLoad: true,
                        alt: icon.description,
                      }
                    : undefined
                }
              />
            </Box>
          )
        })}
      </Carousel>
    </ModuleSection>
  )
}
